import { List, NumberField, TextField } from 'react-admin';
import Datagrid from '../Commons/Datagrid';
import PostPagination from '../Commons/PostPagination';
import ListActions from '../Commons/ListActions';
import { useMediaQuery, createTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import historyTracker from '../Commons/historyTracker';
import { useDataProvider } from "react-admin";
import AuthNotification from '../Commons/AuthNotification';
import { useLocation } from 'react-router-dom';
import { useListController } from 'react-admin';
import { StyleTheme, Style } from '../Commons/Styles.jsx';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => createStyles(StyleTheme));

const RequestList = (props) => {
  const classes = useStyles();
  const theme = createTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const dataProvider = useDataProvider();
  const [auth, setAuth] = useState(false);
  const [openerror, setOpenerror] = useState(false);
  const [elements, setelements] = useState(0);
  const [message, setMessage] = useState('')
  const { setModule } = props;
  const location = useLocation();
  const listContext = useListController(props);

  useEffect(() => {
    (async () => {
      try {
        const records = listContext.data ?? [];

        if (!listContext.isPending)
          setMessage('No Posees Empresas Asociadas');

        setelements(records.length);
        setModule('Reportes');
        setAuth(true);
        setOpenerror(false)
        historyTracker.cleanHistory();
        historyTracker.addPath(location.pathname, 'Compañías', 0);
        if (records.length === 1) {
          navigate('/company/reports/' + records[0].id + '/show');
        }
      }
      catch (error) {
        console.log(error);
      }
    })();
  }, [dataProvider, setModule, location, listContext.data, listContext.isPending, navigate]);

  return (
    <div class="container">
      {auth && elements > 1 ? (
        <div class="row">
          <div class="col-12">
            {isSmall ? (
              <List empty={false} {...props} actions={<ListActions />} bulkActionButtons={false} pagination={<PostPagination />}>
                <Datagrid {...props} rowClick="show">
                  <NumberField source="companyCode" style={Style.fieldList} label="Código" cellClassName={classes.fields} />
                  <TextField source="name" style={Style.fieldList} label="Orden" cellClassName={classes.fields} />
                </Datagrid>
              </List>
            ) : (
              <List empty={false} {...props} actions={<ListActions />} bulkActionButtons={false} pagination={<PostPagination />}>
                <Datagrid {...props} rowClick="show" style={Style.DataGrid}>
                  <NumberField source="companyCode" style={Style.fieldList} label="Código" cellClassName={classes.fields} />
                  <TextField source="name" style={Style.fieldList} label="Empresa" cellClassName={classes.fields} />
                </Datagrid>
              </List>
            )}
          </div>
        </div>) : auth && elements === 0 ? (
          <div class="row">
            <div class="col-2"></div>
            <div class="col-8 common" >
              <h2>{message}</h2>
            </div>
          </div>) :
        (<AuthNotification openerror={openerror} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)
      }
    </div>
  )
};

export default RequestList;